<template>
  <div>
    <portlet :clase="'container col-md-12'" > 
      <template slot="actions">      
        <a class="btn btn-circle btn-icon-only green" href="#portlet-agr-tramite" data-toggle='modal' title='Agregar grupo'><i class="fa fa-wrench"></i></a>
      </template>
      <template slot="caption">
            <i class="fa fa-bank"></i><span class="caption-subject bold uppercase"> Tramites</span>
      </template>      
      <template slot="body">
        <div class="row">
            <div class="form-group col-md-2 col-ms-12">
                <span class="help-block"></span>
                <label >Tramite (Selecciona)</label>
            </div>
            <div class="form-group col-md-3 col-ms-12">
                <select2 class="form-control" :options="options" v-model="tramite" @eventchange="changeTramite()">
                    <option :value="0">--------</option>
                    <option v-for="b in data_tramite" :value="b.id"> {{ b.desc}}</option>
                </select2>
            </div>
            <div class="form-group col-md-2 col-ms-12">
                <span class="help-block"></span>
                <label >Grupo (Selecciona)</label>
            </div>
            <div class="form-group col-md-3 col-ms-12">
                <div class="form-group">
                    <select2 class="form-control" :options="options" v-model="categoria">
                        <option :value="0">--------</option>
                        <option v-for="b in data_categorias" :value="b.id"> {{ b.descripcion}}</option>
                    </select2>
                </div>
            </div>
            <div class="form-group col-md-2 col-ms-12" :hidden="!hidden_btn_categoria">
                <div class="form-group">
                    <button class="btn btn-success" v-on:click="updateCategoria()"><i class="fa fa-exchange"></i> Actualizar</button>
                </div>
            </div>
        </div>
        <div class="row" >
            <div class="form-group col-md-2 col-ms-12">
                <div class='md-checkbox' :hidden="!hidden_check_tramite">
                    <input type='checkbox' id='prelacion' name="checkFile" class='md-check '  v-on:click="savePrelacion()">
                    <label for='prelacion'> <span></span> <span class='check'></span> <span class='box'> </span>  Prelación. </label>
                </div>
            </div>
            <div class="form-group col-md-2 col-ms-12" :hidden="!hidden_check_tramite">
                <div class='md-checkbox'>
                    <input type='checkbox' id='divisa' name="checkdivisa" class='md-check '  v-on:click="saveDivisa()">
                    <label for='divisa'><span></span><span class='check'></span> <span class='box'></span> Configurar divisa. </label>
                </div>
            </div>
            <div class="form-group col-md-2 col-ms-12" :hidden="!hidden_check_firma">
                <div class='md-checkbox'>
                    <input type='checkbox' id='firma' name="checkfirma" class='md-check '  v-on:click="saveFirma()">
                    <label for='firma'><span></span><span class='check'></span> <span class='box'> </span> Requiere Firma. </label>
                </div>
            </div> 
        </div>
      </template>
    </portlet>
    <portlet :clase="'container col-md-12'" > 
        <template slot="actions">      
            <a class="btn btn-circle btn-icon-only green" href="#portlet-orden" data-toggle='modal' title='Orden'><i class="fa fa-wrench"></i></a>          
        </template>
        <template slot="caption">
            <i class="fa fa-bank"></i><span class="caption-subject bold uppercase"> Agregar Agrupacion</span>
        </template>      
        <template slot="body">
            <div class="row">
                <div class="form-group col-md-2 col-ms-12">
                    <label class="sr-only" for="agrupacionNombre">Nueva Agrupacion</label>
                    <input type="text" class="form-control" v-model="nombre_agrupacion" name="agrupacionNombre" autocomplete="off"placeholder="Nueva Agrupación...">
                </div>
                <div class="form-group col-md-1 col-ms-12">
                    <button type="button" class="btn green enableBtn" v-on:click="validarAgrupacion()">Agregar</button>
                </div>
                <div class="form-group col-md-3 col-ms-12">
                    <label >Agrupaciones Registrados (Selecciona)</label> 
                </div>
                <div class="form-group col-md-3 col-ms-12">    
                    <select2 class="form-control" :options="options" v-model="agrupacion" @eventchange="changeAgrupacion()">
                        <option :value="0">--------</option>
                        <option v-for="b in data_agrupacion" :value="b.id"> {{ b.descripcion}}</option>
                    </select2>
                </div>
            </div>
        </template>
    </portlet>
    <portlet :clase="'container col-md-12'" > 
      <template slot="actions">      
        <a class="btn btn-circle btn-icon-only green" href="#portlet-config" data-toggle='modal' title='Agregar cuenta'><i class="fa fa-wrench"></i></a>
      </template>
      <template slot="caption">
            <i class="fa fa-bank"></i><span class="caption-subject bold uppercase"> Tramite {{ texto_tramite }}</span>
      </template>      
      <template slot="body">
        <div class="row">
            <div class="col-md-12">
                <ul id="sortableCampos" class="sortable"style="cursor: -webkit-grab; cursor: grab;">
                    <li class='ui-state-default col-md-12' v-for="b in data_campo_agrupacion" :id="'sortable_campos_' + b.id">
                        <div style='display:none !important;'><input type='checkbox' name='iCampos' :value='b.id'></div>
                        <div class='col-md-1'><span class='ui-icon ui-icon-arrowthick-2-n-s'></span></div>
                        <div class='col-md-8' :title="b.campo_nombre">
                            <p> {{ b.campo_nombre }} </p>
                        </div>
                        <div class='col-md-3'>
                            <a class='btn btn-icon-only blue btn-circle' data-toggle='modal' href='#portlet-config' title='Editar' style='color:#FFF !important;' v-on:click='editarCampo(b.id)'><i class='fa fa-pencil'></i></a>
                            <a class='btn btn-icon-only red btn-circle' title='Eliminar' style='color:#FFF !important;' v-on:click='eliminarCampo(b.id)' v-if="validaCarctarteristica(b.caracteristicas) ==false"><i class='fa fa-minus'></i></a>
                            <a class='btn btn-icon-only blue btn-circle' data-toggle='modal' href='#portlet-detalles' title='Detalles' style='color:#FFF !important;' v-on:click='detalleCaracteritica(b.id)'><i class='fa fa-list'></i></a>
                        </div>
                    </li>
                </ul>
                <div v-if="data_campo_agrupacion.length==0 && !campos_config_load" class="text-center"><h5>Sin registros</h5></div>
                <loadSpinner :showSpinner="campos_config_load" ></loadSpinner>
            </div>
        </div>
      </template>
    </portlet>
    <portlet :clase="'container col-md-12 blockui_sample_3_2_element'" > 
        <template slot="actions">      
            <a class="btn btn-circle btn-icon-only green" href="#portlet-calculo" data-toggle='modal' title='Agregar cuenta'><i class="fa fa-wrench"></i></a>
        </template>
        <template slot="caption">
            <i class="fa fa-bank"></i><span class="caption-subject bold uppercase"> Configuración de Calculos Internos</span>
        </template>      
        <template slot="body">
            <div class="row">
                <div class="col-md-12">
                    <ul id="sortableCalculos" class="sortable" style="cursor: -webkit-grab; cursor: grab;">
                        <li class='ui-state-default col-md-12' v-for="b in data_calculos" :id="'sortable_calculos_' + b.id">
                            <div style='display:none !important;'><input type='checkbox' name='iCalculos' :value='b.id'></div>
                            <div class='col-md-1'><span class='ui-icon ui-icon-arrowthick-2-n-s'></span></div>
                            <div class='col-md-3' :title="b.campo_nombre">
                                <p> {{ b.campo_nombre }} </p>
                            </div>
                            <div class='col-md-3' :title="b.formula_texto">
                                <p> {{ b.formula_texto }} </p>
                            </div>
                            <div class='col-md-1'>
                                <i v-if="b.redondeo" class='icon-close font-red-sunglo'></i>
                                <i v-else class='icon-check font-green'></i>
                            </div>
                            <div class='col-md-2' :title="b.redondeo_nombre">
                                <p> {{ b.redondeo_nombre }} </p>
                            </div>
                            <div class='col-md-2'>
                                <a class='btn btn-icon-only blue btn-circle' data-toggle='modal' href='#portlet-calculo' title='Editar' style='color:#FFF !important;' v-on:click='calculoEditar(b.id)'><i class='fa fa-pencil'></i></a>
                                <a class='btn btn-icon-only red btn-circle' data-toggle="modal" href="#portlet-delete-calculo" title='Eliminar' style='color:#FFF !important;' v-on:click='calculoEliminar(b.id)'><i class='fa fa-minus'></i></a>
                            </div>
                        </li>
                    </ul>
                    <loadSpinner :showSpinner="calculos_load" ></loadSpinner>
                </div>
            </div>
        </template>
    </portlet>
    <modal :id="'portlet-config'" :modal="'modal-lg'" >
        <template slot="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" v-on:click="clearFormConfig()"></button>
            <h4 class="modal-title"> Configurar Tramite</h4>
        </template>
        <template slot="modal-body">
            <div class="row">
                <div class="form-group col-md-6">
                    <label>Campo</label>
                    <select2 class="form-control" :options="options" v-model="campos" :disabled="disable_operacion==true">
                        <option :value="0">--------</option>
                        <option v-for="b in data_campo" :value="b.id"> {{ b.desc }}</option>
                    </select2>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-md-6">
                    <label>Nombre a mostrar</label>
                    <input type="text" v-model="etiqueta" class="form-control" placeholder="Texto que ve el ciudadano" maxlength="200" :disabled="disable_operacion==true">
                    <span class="help-block">Solo afecta a este tramite. Vacio: se muestra el nombre del campo.</span>
                </div>
                <div class="form-group col-md-6">
                    <label>Ayuda (tooltip)</label>
                    <input type="text" v-model="valor_ayuda" name="v_tooltip" class="form-control" placeholder="Texto de ayuda para el ciudadano" maxlength="100" :disabled="disable_operacion==true">
                    <span class="help-block">Vacio: no se muestra el tooltip. Max. 100 caracteres.</span>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-md-3">
                    <label>Tamaño <a href="#large" data-toggle="modal" title="Click mostrar info"><i class="fa fa-question-circle" style="color:blue !important;"></i></a></label>
                    <select2 class="form-control" :options="options" v-model="tamanio" :disabled="disable_operacion==true">
                        <option :value="0">--------</option>
                        <option v-for="b in data_size" :value="b"> {{ b}}</option>
                    </select2>
                    <span class="help-block">Selecciona el Tamaño</span>
                </div>
                <div class="form-group col-md-3">
                    <label>Campo requerido</label>
                    <select2 class="form-control" :options="options" v-model="requerido" :disabled="disable_operacion==true">
                        <option value="false">No</option>
                        <option value="true">Si</option>
                    </select2>
                    <span class="help-block">Opcional</span>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-md-3" >
                    <label>Tipo</label>
                    <select2 class="form-control" :options="options" v-model="tipo" @eventchange="changeTipoCampo()" :disabled="disable_operacion==true">
                        <option :value="0">--------</option>
                        <option v-for="b in data_tipos" :value="b.id"> {{ b.desc }}</option>
                    </select2>
                </div>
                <div class="col-md-9">
                    <div class="row">
                        <div class="form-group col-md-6" v-if="hidden_expreg">
                            <label>Expresión regular</label>
                            <select2 class="form-control" :options="options" v-model="expreg" :disabled="disable_operacion==true">
                                <option :value="0">--------</option>
                                <option v-for="b in data_regex" :value="b.regex"> {{ b.name }}</option>
                            </select2>
                        </div>
                        <div class="form-group col-md-6" v-if="formatos_del_tipo.length > 0">
                            <label>Formato</label>
                            <select2 class="form-control" :options="options" v-model="formato" :disabled="disable_operacion==true">
                                <option :value="0">--------</option>
                                <option v-for="f in formatos_del_tipo" :value="f"> {{ f }}</option>
                            </select2>
                        </div>
                        <div class="form-group col-md-6" v-if="hidden_origen">
                            <label>Origen de la lista</label>
                            <select2 class="form-control" :options="options" v-model="origen" :disabled="disable_operacion==true">
                                <option :value="0">--------</option>
                                <option v-for="b in data_catalogos" :value="b.slug"> {{ b.etiqueta }}</option>
                            </select2>
                            <span class="help-block">-------- : las opciones se capturan abajo.</span>
                        </div>
                        <div class="form-group col-md-12 radioTipos" :hidden="!hidden_file">
                            <label>Tipo de archivo</label>
                            <div class="md-radio-inline">
                                <div class="md-radio">
                                    <input type="radio" id="radio4" name="tramite_config_file_type" class="md-radiobtn" value="pdf" :disabled="disable_operacion==true">
                                    <label for="radio4"><span></span><span class="check"></span><span class="box"></span> Pdf.</label>
                                </div>|
                                <div class="md-radio">
                                    <input type="radio" id="radio5" name="tramite_config_file_type" class="md-radiobtn" value="xlsx" :disabled="disable_operacion==true">
                                    <label for="radio5"><span></span><span class="check"></span><span class="box"></span>Excel.</label>
                                </div>|
                                <div class="md-radio">
                                    <input type="radio" id="radio6" name="tramite_config_file_type" class="md-radiobtn" value="docx" :disabled="disable_operacion==true">
                                    <label for="radio6"><span></span><span class="check"></span><span class="box"></span>Word.</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-3" :hidden="!hidden_date_rango">
                            <label >Fecha Rango</label>
                            <div class="md-checkbox">
                                <input type="checkbox" id="date_rango" name="date_rango" class="md-check"  v-on:change="changeRango()" :disabled="disable_operacion==true">
                                <label for="date_rango"><span></span><span class="check"></span> <span class="box"></span> Rango. </label>
                            </div>
                        </div>
                        <div class="form-group col-md-3" :hidden="!hidden_date_rango_limite">
                            <label >Fecha Rango Limite</label>
                            <div class="md-checkbox">
                                <input type="checkbox" id="date_rango_limite" name="date_rango_limite" class="md-check" :disabled="disable_operacion==true">
                                <label for="date_rango_limite"><span></span><span class="check"></span> <span class="box"></span> Limitar.</label>
                            </div>
                        </div>
                        <div class="form-group col-md-3"  :hidden="!hidden_date_multiple">
                            <label >Fecha Multiple</label>
                            <div class="md-checkbox">
                                <input type="checkbox" id="date_multiple" name="date_multiple" class="md-check" v-on:change="changeMultiple()" :disabled="disable_operacion==true">
                                <label for="date_multiple"><span></span><span class="check"></span> <span class="box"></span> Multiple.</label>
                            </div>
                        </div>
                        <div class="form-group col-md-3" :hidden="!hidden_date_mes">
                            <label >Fecha por Mes</label>
                            <div class="md-checkbox">
                                <input type="checkbox" id="date_mes" name="date_mes" class="md-check" v-on:change="changeMes()" :disabled="disable_operacion==true">
                                <label for="date_mes"><span></span><span class="check"></span> <span class="box"></span> Mensual.</label>
                            </div>
                        </div>
                        <div class="form-group col-md-3" :hidden="!hidden_date_limite">
                            <label >Limite al mes actual</label>
                            <div class="md-checkbox">
                                <input type="checkbox" id="date_limite" name="date_limite" class="md-check" :disabled="disable_operacion==true">
                                <label for="date_limite"><span></span><span class="check"></span> <span class="box"></span> Limitar.</label>
                            </div>
                        </div>
                        <div class="form-group col-md-2" :hidden="!hidden_numeric">
                            <label >Miles</label>
                            <div class="md-checkbox">
                                <input type="checkbox" id="miles" name="miles" class="md-check" :disabled="disable_operacion==true">
                                <label for="miles"><span></span><span class="check"></span> <span class="box"></span> Miles.</label>
                            </div>
                        </div>
                        <div class="form-group col-md-2" :hidden="!hidden_numeric">
                            <label >Decimal</label>
                            <div class="md-checkbox">
                                <input type="checkbox" id="decimal" name="decimal" class="md-check" v-on:change="changeDecimal()" :disabled="disable_operacion==true">
                                <label for="decimal"><span></span><span class="check"></span> <span class="box"></span> Decimal.</label>
                            </div>
                        </div>
                        <div class="form-group col-md-2"  :hidden="!hidden_decimal">
                            <label >Decimales</label>
                            <input type="number" v-model="decimal_longitud" name="decimal_longitud" class="form-control valida-long" min="1" max="4" placeholder="1 a 4" maxlength="1" :disabled="disable_operacion==true">
                        </div>
                        <div class="form-group col-md-3" :hidden="!hidden_numeric">
                            <label>Valor Minimo</label>
                            <input type="text" v-model="valor_min" name="valor_min" class="form-control valida-numeros" :disabled="disable_operacion==true">
                        </div>
                        <div class="form-group col-md-3" :hidden="!hidden_numeric">
                            <label >Valor Máximo</label>
                            <input type="text" v-model="valor_max" name="valor_max" class="form-control valida-numeros" :disabled="disable_operacion==true">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-md-12" v-if="hidden_opciones && origen==0">
                    <label>Opciones</label>
                    <table class="table table-condensed" v-if="opciones.length > 0">
                        <thead><tr><th>Clave</th><th>Texto</th><th></th></tr></thead>
                        <tbody>
                            <tr v-for="(op, i) in opciones">
                                <td>{{ op.clave }}</td>
                                <td>
                                    <input v-if="editando_opcion_index==i" type="text" v-model="editando_opcion_texto" class="form-control" maxlength="200">
                                    <span v-else>{{ op.nombre }}</span>
                                </td>
                                <td>
                                    <template v-if="editando_opcion_index==i">
                                        <a class="btn btn-icon-only btn-success btn-circle" title="Guardar texto" v-on:click="guardarEdicionOpcion(i)"><i class="fa fa-check"></i></a>
                                        <a class="btn btn-icon-only btn-default btn-circle" title="Cancelar" v-on:click="cancelarEdicionOpcion()"><i class="fa fa-times"></i></a>
                                    </template>
                                    <template v-else>
                                        <a class="btn btn-icon-only btn-primary btn-circle" title="Editar texto" v-on:click="editarOpcion(i)"><i class="fa fa-pencil"></i></a>
                                        <a class="btn btn-icon-only btn-danger btn-circle" title="Quitar opcion" v-on:click="quitarOpcion(i)"><i class='fa fa-minus'></i></a>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="row" v-if="es_campo_partida">
                        <div class="col-md-10">
                            <select2 class="form-control" :options="options" v-model="nueva_partida">
                                <option :value="0">-------- Selecciona la partida</option>
                                <option v-for="p in data_partidas" :value="p.id"> {{ p.id }} - {{ p.desc }}</option>
                            </select2>
                        </div>
                        <div class="col-md-2">
                            <button type="button" class="btn blue" v-on:click="agregarOpcionPartida()"><i class="fa fa-plus"></i></button>
                        </div>
                        <div class="col-md-12"><span class="help-block">Las partidas se eligen del catalogo: no se teclean.</span></div>
                    </div>
                    <div class="row" v-else>
                        <div class="col-md-5">
                            <input type="text" v-model="nueva_opcion_clave" class="form-control" placeholder="Clave (lo que se guarda)" maxlength="100">
                        </div>
                        <div class="col-md-5">
                            <input type="text" v-model="nueva_opcion_nombre" class="form-control" placeholder="Texto (lo que se ve)" maxlength="200">
                        </div>
                        <div class="col-md-2">
                            <button type="button" class="btn blue" v-on:click="agregarOpcion()"><i class="fa fa-plus"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-md-3">
                    <label>Dependiente</label>
                    <select2 class="form-control" :options="options" v-model="dependiente" @eventchange="changeDependiente()" :disabled="disable_operacion==true">
                        <option value="false">No</option>
                        <option value="true">Si</option>
                    </select2>
                    <span class="help-block">Opcional</span>
                </div>
                <div class="form-group col-md-5" v-if="dependiente=='true'">
                    <label>Campo</label>
                    <select2 class="form-control" :options="options" v-model="campo_dependiente" :disabled="disable_operacion==true">
                        <option :value="0">--------</option>
                        <option v-for="b in data_campo_config" :value="b.campo_id"> {{ b.campo_nombre }}</option>
                    </select2>
                </div>
                <div class="form-group col-md-4" v-if="dependiente=='true'">
                    <label>Valor</label>
                    <input type="text" class="form-control" placeholder="Valor" name="valor_dependiente" v-model="valor_dependiente" :disabled="disable_operacion==true">
                </div>
                <div class="form-group col-md-12" :hidden="!hidden_tooltip_tipo">
                    <div class="md-checkbox">
                        <input type="checkbox" id="ayuda" name="ayuda" class="md-check" v-on:change="changeTooltip()" :disabled="disable_operacion==true">
                        <label for="ayuda"><span></span><span class="check"></span> <span class="box"></span> Mostrar ayuda (tooltip)</label>
                    </div>
                    <span class="help-block">Opcional</span>
                </div>
                <div class="form-group col-md-12" :hidden="!hidden_ayuda">
                    <label for="v_tooltip">Texto del tooltip</label>
                    <input type="text" v-model="valor_ayuda" name="v_tooltip" class="form-control" placeholder="Texto que verá el ciudadano al pasar el cursor" maxlength="100" :disabled="disable_operacion==true">
                    <span class="help-block">Máximo 100 caracteres.</span> 
                </div>
            </div>
        </template>
        <template slot="modal-footer"> 
            <button type="button" class="btn default" data-dismiss="modal" v-on:click="clearFormConfig()">Cerrar</button>
            <button type="button" class="btn blue" v-on:click="validarFormConfig()" :disabled="disable_operacion==true"><i class="fa fa-check"></i> Guardar</button>
        </template>  
    </modal>
    <modal :id="'portlet-agr-tramite'" :modal="'modal-md'">
        <template slot="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" v-on:click="clearFormCategoria()"></button>
            <h4 class="modal-title"><i class="fa fa-cogs"></i> Nuevo grupo</h4>
        </template>
        <template slot="modal-body">
            <div class="row">
                <div class="form-group col-md-12">
                    <label >Nombre</label>
                    <input type="text" name="nombreGrupo" v-model="nombre_grupo" class="form-control" placeholder="Nombre Grupo">
                </div>
            </div>
        </template>
        <template slot="modal-footer"> 
            <button type="button" class="btn default" data-dismiss="modal" v-on:click="clearFormCategoria()">Cerrar</button>
            <button type="button" class="btn blue" v-on:click="saveCategoria()"><i class="fa fa-check"></i> Guardar</button>
        </template>
    </modal>    
    <modal :id="'portlet-orden'" :modal="'modal-lg'">
        <template slot="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
            <h4 class="modal-title"><i class="fa fa-cogs"></i> Agrupación Orden </h4>
        </template>
        <template slot="modal-body">
            <div class="row">
                <div class="form-group col-md-12">
                    <ul id="sortableAgrupaciones" class="sortable"style="cursor: -webkit-grab; cursor: grab;">
                        <li class='ui-state-default col-md-12' v-for="b in data_agrupacion_sort" :id="'sortable_agrupacion_' + b.id">
                            <div  style='display:none !important;'><input type='checkbox' name='iAgrupacion' :value='b.id'></div>
                            <div class='col-md-1'><span class='ui-icon ui-icon-arrowthick-2-n-s'></span></div>
                            <div class='col-md-9'>
                                <p> {{ b.descripcion }} </p>
                            </div>
                            <div class='col-md-2'>
                                <a class='btn btn-icon-only blue btn-circle' data-toggle='modal' href='#portlet-edit-categoria' title='Editar' style='color:#FFF !important;' v-on:click='editarAgrupacion(b.id)'><i class='fa fa-pencil'></i></a>
                            </div>
                        </li>
                    </ul>
                    <div v-if="data_agrupacion_sort.length==0" class="text-center"><h5>Sin registros</h5></div>
                </div>
            </div>
        </template>
        <template slot="modal-footer">
            <button type="button" class="btn default" data-dismiss="modal">Cerrar</button>
        </template>
    </modal>
    <modal :id="'portlet-edit-categoria'" :modal="'modal-md'">
        <template slot="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" v-on:click="clearAgrupacion()"></button>
            <h4 class="modal-title"><i class="fa fa-cogs"></i> Editar Agrupación</h4>
        </template>
        <template slot="modal-body">
            <div class="row">
                <div class="form-group col-md-12">
                    <label >Nombre</label>
                    <input type="text" name="nombreGrupo" v-model="nombre_agrupacion" class="form-control" placeholder="Nombre Grupo">
                </div>
            </div>
        </template>
        <template slot="modal-footer"> 
            <button type="button" class="btn default" data-dismiss="modal" v-on:click="clearAgrupacion()">Cerrar</button>
            <button type="button" class="btn blue" v-on:click="editAgrupacion()"><i class="fa fa-check"></i> Guardar</button>
        </template>
    </modal>
    <modal :id="'portlet-detalles'" :modal="'modal-lg'">
        <template slot="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" v-on:click="clearAgrupacion()"></button>
            <h4 class="modal-title"><i class="fa fa-list"></i> Detalles</h4>
        </template>
        <template slot="modal-body">
            <div class="row"  style="height:520px  !important;overflow-y:scroll;overflow-y:auto;">
                <div class="col-md-12">
                    <div class="form-group col-md-4"> <label class="text-blob">Nombre</label> <p>{{ texto_nombre_campo }}</p> </div>
                    <div class="form-group col-md-8"> <label class="text-blob">Tipo Campo</label><p>{{ texto_tipo_campo }}</p> </div>
                    <span class="help-block">&nbsp;</span>
                    <table class="table table-reponsive">
                        <thead>
                            <tr><th>Nombre Caracteristica</th><th>Value</th><th></th></tr>
                        </thead>
                        <tbody>
                            <tr v-for="(value, key) in data_caracteristicas">
                                <td v-if="key!='opciones'">{{ key }}</td>
                                <td v-if="key!='opciones'">{{ value }}</td>
                                <td v-if="key!='opciones'"><a class="btn btn-icon-only btn-danger btn-circle" title="Quitar Caracteristica" v-on:click="deleteCaracteristica(key,1)"><i class='fa fa-minus'></i></a></td>
                            </tr>
                            <tr v-if="data_caracteristicas.opciones">
                                <th>Opciones</th> <th></th><th></th>
                            </tr>
                            <tr v-for="(b, index) in data_caracteristicas.opciones"  v-if="data_caracteristicas.opciones">
                                <td v-for="(v, k, i) in b">{{ k }}</td>
                                <td v-for="(v, k, i) in b">{{ v }}</td>
                                <td><a class="btn btn-icon-only btn-danger btn-circle" title="Quitar Caracteristica" v-on:click="deleteCaracteristica(index,0)"><i class='fa fa-minus'></i></a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
        <template slot="modal-footer"> 
            <button type="button" class="btn default" data-dismiss="modal" v-on:click="clearAgrupacion()">Cerrar</button>
        </template>
    </modal>
    <modal :id="'large'" :modal="'modal-lg'">
        <template slot="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
            <h4 class="modal-title"><i class="fa fa-cogs"></i> Ejemplo tamaños de input en fila</h4>
        </template>
        <template slot="modal-body">
        <div class="row">
            <div class="table-responsive">
                <table class="table grid" cellspacing="1">
                    <tbody>
                        <tr><td> 1</td> <td> 1</td> <td> 1</td> <td> 1</td> <td> 1</td> <td> 1</td><td> 1</td> <td> 1</td> <td> 1</td><td> 1</td> <td> 1</td> <td> 1</td></tr>
                        <tr><td colspan="4">4</td> <td colspan="4">4</td> <td colspan="4">4</td></tr>
                        <tr><td colspan="4">4</td> <td colspan="8"> 8</td> </tr>
                        <tr><td colspan="6">6</td><td colspan="6"> 6</td> </tr>
                        <tr><td colspan="12">12</td> </tr>
                    </tbody>
                </table>
            </div>
        </div>
      </template>
      <template slot="modal-footer"> 
        <button type="button" class="btn default" data-dismiss="modal">Close</button>
      </template>  
    </modal>
    <modal :id="'portlet-caracteristica'" :modal="'modal-md'">
        <template slot="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" v-on:click="clearFormCaracteristica()"></button>
            <h4 class="modal-title">Caracteristicas del campo</h4>
        </template>
        <template slot="modal-body">
            <div class="row">
                <div class="form-group col-md-8">
                    <label >Nombre</label>
                    <select2 v-if="es_caracteristica" class="form-control" :options="options" v-model="caract_nombre">
                        <option value="">--------</option>
                        <option v-for="b in data_caracteristicas_validas" :value="b.clave"> {{ b.desc }}</option>
                    </select2>
                    <input v-else type="text" name="nombre" v-model="caract_nombre" class="form-control" >
                    <span class="help-block" v-if="es_caracteristica">Solo estas caracteristicas las lee el portal de trámites.</span>
                </div>
                <div class="col-md-4">
                    <span class="help-block">&nbsp;</span>
                    <div class='md-checkbox'>
                        <input type='checkbox' id='check_caracteristica' name="check_caracteristica" class='md-check' v-model="es_caracteristica">
                        <label for='check_caracteristica'><span></span><span class='check'></span> <span class='box'></span>Agregar como una Caracteristica. </label>
                    </div>
                </div>
                <div class="form-group col-md-8">
                    <label>Value</label>
                    <input type="text" name="valor" v-model="caract_value" class="form-control">
                </div>
            </div>
        </template>
        <template slot="modal-footer"> 
            <button type="button" class="btn default" data-dismiss="modal" v-on:click="clearFormCaracteristica()">Cerrar</button>
            <button type="button" class="btn blue" v-on:click="saveCaracteristica()"><i class="fa fa-check"></i> Guardar</button>
        </template>
    </modal>
    <calculo :data_campos="data_campo_calculo" :data_registro="data_calculo_registro" :orden="data_calculos.length" :tramite_id="tramite" @loadTable="findCalculos()" @formulario="calculoRegistros()"></calculo>
    <modalconfirmation :id="'delete-caracteristicas'" >      
        <template slot="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" v-on:click="clearAgrupacion()"></button>
            <h4 class="modal-title"> Confirmation</h4>
        </template>
        <template slot="modal-body">
            <p>¿Quitar Registro?</p>
        </template>
        <template slot="modal-footer">
            <button type="button" data-dismiss="modal" class="btn default" >Cancelar </button>
            <button type="button" data-dismiss="modal" class="btn green" v-on:click="eliminarCaracteristica()"><i class="fa fa-check"></i> Aceptar</button>
        </template>
    </modalconfirmation>
    <modalconfirmation :id="'portlet-delete'" >      
        <template slot="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"  v-on:click="clearAgrupacion()"></button>
            <h4 class="modal-title"> DETALLE DEL REGISTRO A ELIMINAR</h4>
        </template>
        <template slot="modal-body">
            <p><strong>Campo:</strong> {{ texto_nombre_campo }}</p>
        </template>
        <template slot="modal-footer">
            <button type="button" data-dismiss="modal" class="btn default" v-on:click="clearAgrupacion()">Cancelar </button>
            <button type="button" data-dismiss="modal" class="btn green" v-on:click="deletedCampo()"><i class="fa fa-check"></i> Aceptar</button>
        </template>
    </modalconfirmation>
    <modalconfirmation :id="'portlet-delete-calculo'" >      
        <template slot="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"  v-on:click="clearAgrupacion()"></button>
            <h4 class="modal-title"> DETALLE DEL REGISTRO A ELIMINAR</h4>
        </template>
        <template slot="modal-body">
            <p v-if="list_campos.length>0">Al eliminar el cálculo del campo <strong>{{ texto_nombre_campo }}</strong> se modificará la configuración del cálculo de los campos <strong>({{ list_campos.join(", ") }})</strong>. ¿Desea continuar con esta acción?</p>
            <p v-else>¿Desea eliminar el cálculo del campo <strong>{{ texto_nombre_campo }}</strong>?</p>

        </template>
        <template slot="modal-footer">
            <button type="button" data-dismiss="modal" class="btn default" v-on:click="clearAgrupacion()">Cancelar </button>
            <button type="button" data-dismiss="modal" class="btn green" v-on:click="deleteCalculo()" :disabled="validar_eliminar==true"><i class="fa fa-check"></i> Aceptar</button>
        </template>
    </modalconfirmation>
  </div>
</template>  
<script>
  import axios from 'axios'
  import select2 from './General/Select.vue'
  import portlet from './General/Portlet.vue'
  import modal from './General/Modal.vue'
  import modalconfirmation from './General/ModalConfirmation.vue'
  import tableSample from './Individual/TableCalculos.vue'
  import calculo from './Individual/Calculo.vue'
  import loadSpinner from './General/Spinner.vue'

  export default {
    name: 'ReporteEstadistica',
    components: {axios,select2,portlet,modal,modalconfirmation,tableSample,calculo,loadSpinner},
    data(){
      return{
        data_tramite:[],
        data_categorias:[],
        data_agrupacion:[],
        data_agrupacion_sort:[],
        data_tipos:[],
        data_regex:[],
        data_catalogos:[],
        data_size:[1,2,3,4,5,6,7,8,9,10,11,12],
        data_campo:[],
        data_campo_config:[],
        data_campo_agrupacion:[],
        data_calculos:[],
        data_campo_calculo:[],
        data_calculo_registro:[],
        options:[],
        data_caracteristicas:[],
        renderTable:false,
        tramite:0,
        categoria:0,
        agrupacion:0,
        nombre_grupo:'',
        nombre_agrupacion:'',
        campos:0,
        tamanio:0,
        tipo:0,
        expreg:0,
        origen:0,
        etiqueta:'',
        formato:0,
        opciones:[],
        nueva_opcion_clave:'',
        nueva_opcion_nombre:'',
        nueva_partida:0,
        data_partidas:[],
        editando_opcion_index:-1,
        editando_opcion_texto:'',
        decimal_longitud:'',
        valor_min:'',
        valor_max:'',
        campo_dependiente:0,
        valor_dependiente:'',
        // Se guardan como cadena porque asi viaja "required" en caracteristicas.
        requerido:'false',
        dependiente:'false',
        valor_ayuda:'',
        tooltip_enabled_tipos:[],
        texto_tramite:'',
        hidden_btn_categoria:false,
        hidden_check_tramite:false,
        hidden_check_firma:false,
        id_registro:0,
        detalle_campo:'',
        texto_nombre_campo:'',
        texto_tipo_campo:'',
        cart_item:'',
        cart_tipo:'',
        tipo_id:'',
        caract_nombre:'',
        caract_value:'',
        es_caracteristica:false,
        // Caracteristicas que se capturan aqui. La lista se acota a proposito a lo
        // que un capturista configura: el resto de las claves que tramitesDev lee
        // (propietario, tipo, igual_a, date_end) dependen de como esta armado el
        // tramite, no de la captura, y ofrecerlas aqui invitaba a usarlas a ciegas.
        // valor_operacion tampoco va: la escribe Configuracion de Costos junto con
        // required y formato, y quitandola antes del resto de campos del tramite
        // para que solo uno la tenga. A mano se rompe esa invariante.
        // Las demas (required, size, expreg, opciones, ayuda, dependiente,
        // origen...) las escriben los controles de "Configurar Tramite".
        data_caracteristicas_validas:[
            {clave:"etiqueta", desc:"etiqueta - texto a mostrar en vez del nombre del campo"},
            {clave:"formato",  desc:"formato - moneda, curp, manzana o seleccion"},
        ],
        hidden_expreg:false,
        hidden_origen:false,
        hidden_date_rango:false,
        hidden_date_multiple:false,
        hidden_date_mes:false,
        hidden_date_limite:false,
        hidden_date_rango_limite:false,
        hidden_numeric:false,
        hidden_decimal:false,
        hidden_file:false,
        disable_operacion:false,
        renderCalculo:false,
        lengthMenu:[],
        id_relantionship:0,
        validar_eliminar:false,
        list_campos:[],
        campos_config_load:false,
        calculos_load:false,
      }
    },

    computed:{
        tipo_desc(){
            let t = this.data_tipos.find(item => parseFloat(item.id)==parseFloat(this.tipo));
            return t ? t.desc : '';
        },
        // Valores de "formato" que tramitesDev compara de verdad, por tipo de campo.
        // date y mes no van: los escribe el control de fecha.
        formatos_del_tipo(){
            if(this.tipo_desc=='input' || this.tipo_desc=='numeric'){
                return ['moneda','curp','manzana'];
            }
            if(this.tipo_desc=='results'){
                return ['seleccion'];
            }
            return [];
        },
        hidden_opciones(){
            return this.tipo==3 || this.tipo==4 || this.tipo==5 || this.tipo==6;
        },
        // Las opciones del campo Partida se validan contra el catalogo en el
        // backend; aqui se eligen de la lista para que no se puedan teclear mal.
        es_campo_partida(){
            let c = this.data_campo.find(item => parseFloat(item.id)==parseFloat(this.campos));
            return c ? (c.desc+'').toLowerCase()=='partida' : false;
        }
    },

    methods:{
        findTramites(){
            axios.get(`${process.env.APP_URL}/traux-get-serv`).then((response)=>{
                this.data_tramite=response.data;
            }).catch(error=>{ console.log('Tramites:' + error); });
        },
        findCampos(){
            axios.get(`${process.env.APP_URL}/traux-get-camp`).then((response)=>{
                this.data_campo=response.data;
            }).catch(error=>{ console.log('Campos:' + error); });
        },
        findTipos(){
            axios.get(`${process.env.APP_URL}/traux-get-tcamp`).then((response)=>{
                this.data_tipos=response.data;
            }).catch(error=>{ console.log('Tipos:' + error); });
        },
        findRegex(){
            axios.get(`${process.env.APP_URL}/traux-regex`).then((response)=>{
                this.data_regex=response.data.Response;
            }).catch(error=>{ console.log('Regex:' + error); });
        },
        // Solo las partidas configuradas para el tramite seleccionado (serv_partidas.id_servicio).
        findPartidasCatalogo(){
            this.data_partidas=[];
            if(this.tramite==0){ return; }
            axios.post(`${process.env.APP_URL}/traux-find-partida`,{id_tipo_servicio:this.tramite}).then((response)=>{
                let data = typeof(response.data)=="string" ? JSON.parse(response.data) : response.data;
                this.data_partidas = data.map(item => ({id:item.id, desc:item.name}));
            }).catch(error=>{ console.log('Partidas:' + error); });
        },
        agregarOpcion(){
            if(this.nueva_opcion_clave=='' || this.nueva_opcion_nombre==''){
                this.notifications("400","Clave y texto de la opcion, Requeridos!");
                return;
            }
            // select/multiple guardan el objeto {clave,nombre} completo al elegir
            // (SelectComponent en tramitesDev), asi que dos opciones con la misma
            // clave no pierden cual se eligio.
            // option (radio) hoy reconstruye el texto buscando la clave en el
            // catalogo (OptionComponent.vue en tramitesDev), asi que con clave
            // duplicada puede mostrar el texto de la opcion equivocada - pendiente
            // ajustar tramitesDev para que guarde el objeto completo igual que
            // select/multiple. Se permite aqui de cualquier forma por necesidad
            // de negocio (ver tramite 1107).
            let permiteClaveDuplicada = this.tipo==3 || this.tipo==4 || this.tipo==5;
            if(!permiteClaveDuplicada && this.opciones.find(op => op.clave == this.nueva_opcion_clave)){
                this.notifications("400","Esa clave ya esta en la lista");
                return;
            }
            this.opciones.push({clave:this.nueva_opcion_clave, nombre:this.nueva_opcion_nombre});
            this.nueva_opcion_clave='';
            this.nueva_opcion_nombre='';
        },
        agregarOpcionPartida(){
            if(this.nueva_partida==0){
                this.notifications("400","Selecciona la partida, Requerido!");
                return;
            }
            let p = this.data_partidas.find(item => item.id == this.nueva_partida);
            if(!p){ return; }
            if(this.opciones.find(op => op.clave == p.id)){
                this.notifications("400","Partida previamente agregada.");
                return;
            }
            this.opciones.push({clave:p.id, nombre:p.desc});
            this.nueva_partida=0;
        },
        quitarOpcion(i){
            this.opciones.splice(i,1);
            this.cancelarEdicionOpcion();
        },
        // Permite corregir el texto visible de una opcion ya agregada (p.ej. una
        // partida tomada del catalogo) sin tener que quitarla y volver a elegirla.
        editarOpcion(i){
            this.editando_opcion_index=i;
            this.editando_opcion_texto=this.opciones[i].nombre;
        },
        guardarEdicionOpcion(i){
            if(this.editando_opcion_texto==''){
                this.notifications("400","Texto de la opcion, Requerido!");
                return;
            }
            this.opciones[i].nombre=this.editando_opcion_texto;
            this.cancelarEdicionOpcion();
        },
        cancelarEdicionOpcion(){
            this.editando_opcion_index=-1;
            this.editando_opcion_texto='';
        },
        // opciones se guarda como [{clave: texto}], que es el formato que lee
        // tramitesDev y el que ya escribia traux-add-caract.
        opcionesParaGuardar(){
            return this.opciones.map(op => { let o={}; o[op.clave]=op.nombre; return o; });
        },
        opcionesDesdeCaracteristicas(lista){
            if(!lista || lista.length==0){ return []; }
            return lista.map(op => {
                if(op.clave!==undefined && op.nombre!==undefined){ return {clave:op.clave, nombre:op.nombre}; }
                let clave = Object.keys(op)[0];
                return {clave:clave, nombre:op[clave]};
            });
        },
        findCatalogos(){
            // Los slugs los publica la misma lista blanca que valida
            // /obtener-catalogo/{slug}, asi el combo no ofrece uno invalido.
            axios.get(`${process.env.APP_URL}/obtener-catalogos`).then((response)=>{
                this.data_catalogos=response.data;
            }).catch(error=>{ console.log('Catalogos:' + error); });
        },
        findCategorias(){
            let selct=this.categoria;
            axios.get(`${process.env.APP_URL}/listarCategorias`).then((response)=>{
                this.data_categorias=response.data;
                setTimeout(() => { this.categoria=selct;  }, 300);
            }).catch(error=>{ console.log('Categorias:' + error); });
        },
        findCalculos(){
             this.data_calculos=[];
            this.calculos_load=true;
            axios.get(`${process.env.APP_URL}/calculo-tramite/${this.tramite}`).then((response)=>{
                this.data_calculos=response.data.response;
                this.calculos_load=false;
            }).catch(error=>{ console.log('Categorias:' + error); this.loagingC(false);});
        },
        findCalculosCampos(){
            this.data_campo_calculo=[];
            axios.post(`${process.env.APP_URL}/calculo-campos`,{id_tramite:this.tramite}).then((response)=>{
                this.data_campo_calculo=response.data.response;
            }).catch(error=>{ console.log('Categorias:' + error); });
        },
        changeTramite(){
            $("#prelacion").prop("checked", false);
            $("#divisa").prop("checked", false);
            $("#firma").prop("checked", false);
            this.hidden_check_tramite=false;
            this.hidden_btn_categoria=false;
            this.hidden_check_firma=false;
            let tr= this.data_tramite.find(item => parseFloat(item.id)==parseFloat(this.tramite));
            this.texto_tramite= tr ? tr.desc : '';
            this.findCamposAgrupaciones(false,0);
            this.findAgrupaciones(true,true);
            this.agrupacion=0
            if(this.tramite!=0){
                this.hidden_check_tramite=true;
                this.hidden_btn_categoria=true;
            }
            this.findfirma();
            this.findCalculos();
            this.findCalculosCampos();
            this.findPartidasCatalogo();
        },
        changeAgrupacion(){
            if(this.agrupacion==0){
                this.data_campo_agrupacion=[];
            }else{
                this.findCamposAgrupaciones(true,this.agrupacion);
            }
        },
        changeDependiente(){
            this.campo_dependiente=0;
            this.valor_dependiente='';
        },
        changeTipoCampo(){
            let tipo= this.data_tipos.find(item => parseFloat(item.id)==parseFloat(this.tipo));
            this.hiddenCampos();
            this.expreg=0;
            this.origen=0;
            this.formato=0;
            this.unchecks_inputs();
            if(this.tipo==0){return;}
            if(tipo.desc=="numeric"){
                this.hidden_numeric=true
            }else if(tipo.desc=="file"){
                this.hidden_file=true;
            }else if(tipo.desc=="date"){
                this.hidden_date_rango=true;
                this.hidden_date_multiple=true;
                this.hidden_date_mes=true;
            }else if(tipo.desc=="input"){
                this.hidden_expreg=true;
            }
            // Solo select y multiple: son los unicos que tramitesDev pinta con
            // SelectComponent, el unico que lee "origen".
            this.hidden_origen = (tipo.desc=="select" || tipo.desc=="multiple");
        },
        changeRango(){
            let check=$("#date_rango").prop("checked");
            this.uncheck_dates(false,true,true,true,true);
            if(check){
                this.hidden_dates(true,false,false,false,true);
            }else{
               this.hidden_dates(true,true,true,false,false);
            }
        },
        changeMultiple(){
            let check=$("#date_multiple").prop("checked");
            this.uncheck_dates(true,false,true,true,true);
            if(check){
                this.hidden_dates(false,true,true,false,false);
            }else{
                this.hidden_dates(true,true,true,false,false);
            }
        },
        changeMes(){
            let check=$("#date_mes").prop("checked");
            $("#date_limite").prop("checked",false);
            if(check){
                this.hidden_date_limite=true;
            }else{
                this.hidden_date_limite=false;
            }
        },
        changeDecimal(){
            let check=$("#decimal").prop("checked");
            this.decimal_longitud='';
            if(check){
                this.hidden_decimal=true;
            }else{
                this.hidden_decimal=false;
            }
        },
        findfirma(){
            axios.get(`${process.env.APP_URL}/get-firma-find/${this.tramite}`)
             .then((response)=>{
                let resp=response.data;
                if(resp==null || resp=="null" || resp=="[]"){
                    this.hidden_check_firma=false;
                }else{
                    let fr= resp.find(item => item.firma==true);
                    if(fr){
                        this.hidden_check_firma=true;
                         $("#firma").prop("checked", fr.firma);
                    }
                }
            }).catch(error=>{ console.log('CamposAgrupaciones:' + error); });
        },
        findAgrupaciones(ctramite,sort){
            let selct=this.agrupacion;
            axios.post(`${process.env.APP_URL}/traux-agrupacion`,{id_tramite:this.tramite})
            .then((response)=>{
                let agr=response.data;
                this.data_agrupacion=response.data;
                if(ctramite){
                    let conf_c= agr.find(item => item.check !== null);
                    let conf_d= agr.find(item => item.divisa !==null);
                    let conf_cat= agr[agr.length - 1];
                    if(conf_c){ $("#prelacion").prop("checked", conf_c.check);}
                    if(conf_d){ $("#divisa").prop("checked", conf_d.divisa);}
                    this.categoria=conf_cat.id_categoria == null ? 0 : conf_cat.id_categoria;
                }
                if(sort){
                   this.data_agrupacion_sort=response.data
                }
                setTimeout(() => { this.agrupacion=selct; }, 400);
            }).catch(error=>{ console.log('CamposAgrupaciones:' + error); });
        },
        findCamposAgrupaciones(tipo,agrupacion){
            this.data_campo_agrupacion=[];
            this.campos_config_load=true;
            axios.post(`${process.env.APP_URL}/traux-get-relcamp`,{tramiteid:this.tramite,agrupacion_id:agrupacion})
             .then((response)=>{
                if(tipo){
                    this.data_campo_agrupacion=response.data;
                }else{
                    this.data_campo_config=response.data;
                }
                this.campos_config_load=false;
            }).catch(error=>{ console.log('CamposAgrupaciones:' + error); this.campos_config_load=false;});
        },
        savePrelacion(){
            let check=$("#prelacion").prop("checked") ? "true" : "false";
            axios.post(`${process.env.APP_URL}/traux-prelacion`,{id_tramite:this.tramite, prelacion:check})
            .then((response)=>{
                this.notifications(response.data.Code,response.data.Message);
                if(response.data.Code !== "200"){
                    $("#prelacion").prop('checked', false);
                }
            }).catch(error=>{ console.log('CamposAgrupaciones:' + error); $("#prelacion").prop('checked', false); });
        },
        saveDivisa(){
            let check=$("#divisa").prop("checked");
            axios.post(`${process.env.APP_URL}/traux-divisa`,{id_tramite:this.tramite, divisa:check})
            .then((response)=>{
                this.notifications(response.data.Code,response.data.Message);
                if(response.data.Code !== "200"){
                    $("#divisa").prop('checked', false);
                }
            }).catch(error=>{ console.log('CamposAgrupaciones:' + error); $("#divisa").prop('checked', false); });
        },
        saveFirma(){
            let check=$("#firma").prop("checked");
            axios.post(`${process.env.APP_URL}/update-firma`,{tramite_id:this.tramite, firma:check})
            .then((response)=>{
                this.notifications(response.data.Code,response.data.Message);
                 if(response.data.Code !== "200"){
                    $("#firma").prop('checked', false);
                }
            }).catch(error=>{ console.log('CamposAgrupaciones:' + error); $("#firmna").prop('checked', false);});
        },
        saveCategoria(){
            if(this.nombre_grupo==''){
                this.notifications("400","Nombre de grupo, requerido!");
                return;
            }
            axios.post(`${process.env.APP_URL}/traux-insert-categoria`,
            {categoria: this.nombre_grupo})
            .then((response)=>{
                this.notifications(response.data.Code,response.data.Message);
                this.clearFormCategoria();
                this.findCategorias();
            }).catch(error=>{ console.log('uCategorias:' + error); });
        },
        validarAgrupacion(){
            if(this.nombre_agrupacion==''){
                this.notifications("400","Campo agrupación, Requerido!");
                return ;
            }else if(this.tramite==0){
                this.notifications("400","Selecciona el Tramite, Requerido!");
                return ;
            }else if(this.categoria==0){
                this.notifications("400","Selecciona Tipo Tramite, Requerido!");
                return ;
            }
            this.saveAgrupacion();
        },
        validarFormConfig(){
            let fileTypeChecked=$('input[name="tramite_config_file_type"]:checked');
            let option= fileTypeChecked.length ? fileTypeChecked.val() : null;
            let stipos= this.data_tipos.find(item => parseFloat(item.id)==parseFloat(this.tipo));
            var miles=$("#miles").prop("checked");
            let decimal = $("#decimal").prop('checked');
            var requerido=this.requerido=='true' ? "true" : "false";
            var date_mes=$("#date_mes").prop("checked");
            var date_limite=$("#date_limite").prop("checked");
            var date_multiple=$("#date_multiple").prop("checked");
            var date_rango=$("#date_rango").prop("checked");
            var date_rango_limite=$("#date_rango_limite").prop("checked");
            let valor_min=$("#valor_min").val();
            let valor_max=$("#valor_max").val(); 
            let dependiente = this.dependiente=='true';
            // La ayuda ya no tiene checkbox: se guarda si trae texto. Vacia se omite,
            // y como editarTramite borra "ayuda" antes de mezclar lo que recibe, eso
            // equivale a la casilla desmarcada de antes.
            let ayuda=(this.valor_ayuda+'').trim()!='';
            let valCheck={"required": requerido};
            if(this.agrupacion==0){
                this.notifications("400","Agrupación sin seleccionar, Requerido!")
                return;
            }else if(this.tramite==0){
                this.notifications("400","Tramite sin seleccionar, Requerido!")
                return;
            }else if(this.campos==0){
                this.notifications("400","Campo sin seleccionar, Requerido!")
                return;
            }else if(this.tipo==0){
                this.notifications("400","Tipo sin seleccionar, Requerido!")
                return;
            }else if(stipos && stipos.desc=="file"){
                if(!option || option===""){
                     this.notifications("400","Selecciona el Tipo File, Requerido!")
                    return;
                }
            }
            if(this.valor_min !== '' || this.valor_min !== ''){
                if(parseFloat(this.valor_min.length)==0 || parseFloat(this.valor_min)==0){
                    this.notifications("400","Valor minimo y maximo, Requerido!")
                    return;
                }
                if(parseFloat(valor_max)<parseFloat(valor_min)){
                    this.notifications("400","Valor maximo, Requerido!")
                    return;
                }
            }
            if(decimal){
                if(this.decimal_longitud=='' || parseInt(this.decimal_longitud==0)){
                    this.notifications("400","Valor decimal longitud, Requerido!")
                    return;
                } 
            }
            if(dependiente){
                if(this.campo_dependiente==0){
                    this.notifications("400","Campo dependiente, Requerido!")
                    return;
                }
                if(this.campo_dependiente==this.campos){
                     this.notifications("400","Seleccione un campo dependiente diferente, Requerido!")
                    return;
                }
                if(this.valor_dependiente==''){
                    this.notifications("400","Valor dependiente, Requerido!")
                    return;
                } 
            }
            if(ayuda && (!this.valor_ayuda || String(this.valor_ayuda).trim()==='')){
                this.notifications("400","Indique el texto del tooltip o desactive la ayuda.")
                return;
            }
            if(this.tamanio!=0){
                Object.assign(valCheck,{"size":this.tamanio});
            }
            if(this.tipo == 3 || this.tipo == 4 || this.tipo == 5 || this.tipo == 6){
                // Con origen la lista viene del catalogo: las opciones capturadas
                // se ignorarian, asi que no se guardan.
                let usa_origen = this.hidden_origen && this.origen!=0;
                Object.assign(valCheck,{"opciones": usa_origen ? [] : this.opcionesParaGuardar()});
                if(usa_origen){
                    Object.assign(valCheck,{"origen":this.origen});
                }
            }else if(this.tipo == 10 ){
                Object.assign(valCheck,{"formato":"date"});
                if(date_mes){Object.assign(valCheck,{"formato":"mes"});}
                Object.assign(valCheck,{"date_limit":date_limite,"date_multiple":date_multiple,"date_range":date_rango,"date_range_limit": date_rango_limite});           
            }
            if(stipos){
                if(stipos.desc=="numeric"){
                    let expreg="^[0-9]{0,20}$";
                    if(miles){Object.assign(valCheck,{"miles":miles});}
                    if(decimal){
                        expreg="^[0-9]*\.[0-9]{"+this.decimal_longitud+"}$";
                        Object.assign(valCheck,{"decimal_longitud":this.decimal_longitud});
                    }
                    if(!miles){
                        Object.assign(valCheck,{"expreg":expreg});
                    }
                    Object.assign(valCheck,{"valor_min": this.valor_min,"valor_max": this.valor_max});
                    if(this.valor_max.length>0 && this.valor_min.length>0){
                        Object.assign(valCheck,{"required":"true"});
                    }
                }
                if(stipos.desc=="input"){
                    if(this.expreg!=0){  Object.assign(valCheck,{"expreg":this.expreg}); }
                }
            }
            if(ayuda){
                Object.assign(valCheck,{"ayuda":(this.valor_ayuda+'').trim()});
            }
            if(dependiente){
                Object.assign(valCheck,{"ocultar":dependiente,"valor_dependiente":this.valor_dependiente,"dependiente":this.campo_dependiente});
            }
            // Se manda siempre, aun vacia: editarTramite conserva las claves que no
            // recibe, asi que omitirla dejaria imposible borrar una etiqueta. Vacia
            // es falsy y tramitesDev cae al nombre del campo, que es lo que se espera.
            Object.assign(valCheck,{"etiqueta":(this.etiqueta+'').trim()});
            // Se manda siempre que aplique al tipo: editarTramite borra formato del
            // registro y lo repone solo con lo que reciba, asi que omitirlo lo pierde.
            if(this.formatos_del_tipo.length > 0 && this.formato!=0){
                Object.assign(valCheck,{"formato":this.formato});
            }
            let data={id: this.id_registro,
                tramiteid: this.tramite,
                campoid:[this.campos],
                tipoid: [this.tipo],
                tipo_campo: stipos.desc,
                caracteristicas:[JSON.stringify(valCheck)],
                agrupacion_id: this.agrupacion,
                orden: this.data_campo_agrupacion.length + 1,
                fileT:option
            };
            if(this.id_registro==0){
                this.saveConfigCampo(data);
            }else{
                this.editConfigCampo(data);
            }
        },
        saveConfigCampo(data){
             axios.post(`${process.env.APP_URL}/traux-add-serv`,data)
            .then((response)=>{
                this.notifications(response.data.Code,response.data.Message);
                this.clearFormConfig();
                this.findCamposAgrupaciones(false,0);
                this.changeAgrupacion();
                this.findCalculosCampos();
            }).catch(error=>{ console.log('saveConfigCampo:' + error); });
        },
        editConfigCampo(data){
             axios.post(`${process.env.APP_URL}/traux-edit-relcamp`,data)
            .then((response)=>{
                this.notifications(response.data.Code,response.data.Message);
                this.clearFormConfig();
                this.findCamposAgrupaciones(false,0);
                this.changeAgrupacion();
                this.findCalculosCampos();
            }).catch(error=>{ console.log('saveConfigCampo:' + error); });
        },
        saveAgrupacion(){
            let contador= this.data_agrupacion.length;
            axios.post(`${process.env.APP_URL}/guardar-agrupacion`,
            {descripcion: this.nombre_agrupacion, id_tramite: this.tramite, id_categoria: this.categoria, orden: contador})
            .then((response)=>{
                this.notifications(response.data.Code,response.data.Message);
                this.findAgrupaciones(false,true);
                this.nombre_agrupacion='';
            }).catch(error=>{ console.log('uCategorias:' + error); });
        },
        saveCaracteristica(){
            let checkcaract=this.es_caracteristica ? 'true' : 'false';
            let validar=this.data_calculos.find(item => parseFloat(item.id_relationship) == parseFloat(this.id_registro));
            let validarUso=this.verificarCampoUso(this.id_registro);
            if(validar || validarUso.length>0){
               this.notifications("400","El campo cuenta con un cálculo configurado");
                return;
            }
            if(this.caract_nombre==''){
                this.notifications("400","Nombre sin seleccionar, Requerido!");
                return;
            }
            axios.post(`${process.env.APP_URL}/traux-add-caract`,
            { id: this.id_registro,tipo: this.tipo_id, nombre:this.caract_nombre, valor: this.caract_value, caracteristica:checkcaract})
            .then((response)=>{
                this.notifications(response.data.Code,response.data.Message);
                this.changeAgrupacion();
                this.findCalculosCampos();
                this.caract_nombre='';
                this.caract_value='';
            }).catch(error=>{ console.log('uCategorias:' + error); });
        },
        editarCampo(id){
            this.id_registro=id;
            let regs= this.data_campo_agrupacion.find(item => parseFloat(item.id) == parseFloat(id));
            if(regs){
                this.campos=regs.campo_id;
                this.tipo=regs.tipo_id;
                this.changeTipoCampo();
                let carac=JSON.parse(regs.caracteristicas);
                let relacionUso=this.verificarCampoUso(regs.id);
                let validar=this.data_calculos.find(item => parseFloat(item.id_relationship) == parseFloat(id));
                this.requerido = carac.required=="true" ? 'true' : 'false';
                if(typeof(carac.date_multiple)!="undefined"){
                    if(carac.date_multiple==true){
                       setTimeout(() => {  $("#date_multiple").prop("checked", true); this.changeMultiple(); }, 300);
                    }
                }
                if(typeof(carac.date_range)!="undefined"){
                    if(carac.date_range==true){
                       setTimeout(() => {  $("#date_rango").prop("checked", true); this.changeRango();}, 300);
                    }
                }
                if(typeof(carac.date_range_limit)!="undefined"){
                    if(carac.date_range_limit==true){
                        setTimeout(() => { $("#date_rango_limite").prop("checked", true); }, 400);
                    }
                }
                if(typeof(carac.formato)!="undefined"){
                    if(carac.formato=="mes"){
                        setTimeout(() => { $("#date_mes").prop("checked", true); this.changeMes();}, 300);
                    }
                }
                if(typeof(carac.date_limit)!="undefined"){
                    if(carac.date_limit==true){
                        setTimeout(() => { $("#date_limite").prop("checked", true); }, 400);
                    }
                }
                if(typeof(carac.miles)!="undefined"){
                    if(carac.miles){
                       setTimeout(() => {  $("#miles").prop("checked", true); }, 300);
                    }
                } 
                if(typeof(carac.expreg)!="undefined"){
                    if(carac.expreg.includes("[0-9]*.[0-9]")){
                       setTimeout(() => {  $("#decimal").prop("checked", true); }, 300);
                    }
                }
                if(typeof(carac.ayuda)!="undefined"){
                    // El select2 de Tipo dispara @eventchange (unchecks_inputs) de
                    // forma asincrona al asignar this.tipo arriba, y eso borra
                    // valor_ayuda despues de este punto. Se asigna con delay para
                    // que quede firme una vez que ese reset ya paso.
                    setTimeout(() => { this.valor_ayuda=carac.ayuda; }, 300);
                }
                if(typeof(carac.decimal_longitud)!="undefined"){
                    if(carac.decimal_longitud){
                        setTimeout(() => {  this.hidden_decimal=true; this.decimal_longitud=carac.decimal_longitud; }, 400);
                    }
                }
                if(typeof(carac.valor_min)!="undefined" && typeof(carac.valor_max)!="undefined"){
                  setTimeout(() => { 
                    this.valor_min=carac.valor_min;
                    this.valor_max=carac.valor_max; }, 300); 
                }
                if(typeof(carac.valor_operacion)!=="undefined"){
                    if(carac.valor_operacion==true){
                        this.disable_operacion=true;
                    }
                }else{
                    if(validar || relacionUso.length>0){
                        this.disable_operacion=true;
                    }else{
                        this.disable_operacion=false;
                    }
                }
                if(typeof(carac.size)!=='undefined'){
                    this.tamanio=carac.size;
                }
                if(typeof(carac.expreg)!=='undefined'){
                   setTimeout(() => { this.expreg=carac.expreg; }, 300);
                }
                if(typeof(carac.origen)!=='undefined' && carac.origen){
                   setTimeout(() => { this.origen=carac.origen; }, 300);
                }
                if(typeof(carac.etiqueta)!=='undefined'){
                    this.etiqueta=carac.etiqueta;
                }
                if(typeof(carac.formato)!=='undefined'){
                   setTimeout(() => { this.formato=carac.formato; }, 300);
                }
                this.opciones=this.opcionesDesdeCaracteristicas(carac.opciones);
                if(typeof(carac.accept)!=="undefined" && carac.accept){
                    setTimeout(() => {
                        $("input[name=tramite_config_file_type][value='"+carac.accept+"']").prop("checked",true);
                    }, 300);
                }
                if(typeof(carac.ocultar)!="undefined"){
                    // El select2 de Dependiente dispara @eventchange (changeDependiente)
                    // de forma asincrona al asignar this.dependiente arriba, y eso borra
                    // campo_dependiente y valor_dependiente. Ambos se asignan juntos con
                    // delay para que queden firmes una vez que ese reset ya paso.
                    this.dependiente = carac.ocultar ? 'true' : 'false';
                    setTimeout(() => {
                        this.campo_dependiente=carac.dependiente;
                        this.valor_dependiente=carac.valor_dependiente;
                    }, 300);
                }
             }
        },
        editarAgrupacion(id){
            this.id_registro=id;
            let registro= this.data_agrupacion.find(item => parseFloat(item.id) == parseFloat(id));
            if(registro){
                this.nombre_agrupacion=registro.descripcion;
            }
        },
        editAgrupacion(){
            if(this.nombre_agrupacion == ''){
                this.notifications("400","Nombre agrupación, Requerido!");
                return ;
            }
            axios.post(`${process.env.APP_URL}/edit-agrupacion`,
            {id: this.id_registro, descripcion: this.nombre_agrupacion, id_tramite:this.tramite, id_categoria: this.categoria})
            .then((response)=>{
                this.notifications(response.data.Code,response.data.Message);
                this.findAgrupaciones(false,true);
                this.clearAgrupacion();
            }).catch(error=>{ console.log('uCategorias:' + error); });
        },
        calculoEditar(id){
            this.data_calculo_registro=[];
            let dta=this.data_calculos.find(item => item.id == id);
            if(dta){
                this.data_calculo_registro=dta;
            }
        },
        updateCategoria(){
            if(this.categoria==0){
                this.notifications("400","Selecciona una Categoria");
                return;
            }
            axios.post(`${process.env.APP_URL}/traux-update-categoria`,
            {tramite_id:this.tramite, categoria_id:this.categoria})
            .then((response)=>{
                this.notifications(response.data.Code,response.data.Message);
            }).catch(error=>{ console.log('uCategorias:' + error); });
        },
        relationshipAdd(id){
            let validar=this.data_calculos.find(item => parseFloat(item.id_relationship) == parseFloat(id));
            let validarUso=this.verificarCampoUso(id);
            if(validar || validarUso.length>0){
               this.notifications("400","El campo cuenta con un cálculo configurado");
                return;
            }
            $("#portlet-caracteristica").modal("show");
            this.id_registro=id;
            let dta= this.data_campo_agrupacion.find(item => parseFloat(item.id) == parseFloat(id));
            if(dta){
                this.tipo_id=dta.tipo_id;
                this.es_caracteristica = !(dta.tipo_nombre=="option" || dta.tipo_nombre=="select");
            }
        },
        eliminarCampo(id){
            let validar=this.data_calculos.find(item => parseFloat(item.id_relationship) == parseFloat(id));
            let validarUso=this.verificarCampoUso(id);
            if(validar || validarUso.length>0){
               this.notifications("400","El campo cuenta con un cálculo configurado");
                return;
            } 
            setTimeout(() => { $("#portlet-delete").modal("show");  }, 200);
            let dta= this.data_campo_agrupacion.find(item => parseFloat(item.id) == parseFloat(id));
            this.id_registro=id;
            if(dta){
                this.texto_nombre_campo= dta.campo_nombre;
            }
        },
        deletedCampo(){
            axios.post(`${process.env.APP_URL}/traux-del-relcamp`,
            {id:this.id_registro})
            .then((response)=>{
                this.notifications(response.data.Code,response.data.Message);
                this.changeAgrupacion();
                this.findCamposAgrupaciones(false,0);
                this.id_registro=0;
            }).catch(error=>{ console.log('uCategorias:' + error); });
        },
        detalleCaracteritica(id){
            this.id_registro=id;
            let dta= this.data_campo_agrupacion.find(item => parseFloat(item.id) == parseFloat(id));
            if(dta){
                this.texto_nombre_campo= dta.campo_nombre;
                this.texto_tipo_campo= dta.tipo_nombre;
                this.data_caracteristicas= JSON.parse(dta.caracteristicas);
            }
        },
        deleteCaracteristica(item,caracteristica_){
            this.cart_item=item;
            this.cart_tipo=caracteristica_;
            let validar=this.data_calculos.find(item => parseFloat(item.id_relationship) == parseFloat(this.id_registro));
            let validarUso=this.verificarCampoUso(this.id_registro);
            if(validar || validarUso.length>0){
               this.notifications("400","El campo cuenta con un cálculo configurado");
                return;
            }
            $("#delete-caracteristicas").modal("show");
        },
        eliminarCaracteristica(){
            axios.post(`${process.env.APP_URL}/traux-delete-caract`, {id: this.id_registro, key_caracteristica:this.cart_item, caracteristica:this.cart_tipo})
            .then((response)=>{
                this.notifications(response.data.Code,response.data.Message);
                this.changeAgrupacion();
                this.data_caracteristicas= JSON.parse(response.data.caracteristicas);
            }).catch(error=>{
                console.log(error);
                this.notifications(400,"Error al actualizar la renumeración");
            });
        },
        calculoEliminar(id){
            this.validar_eliminar=true;
            let clc=this.data_calculos.find(item => item.id==id);
            if(clc){
                this.id_registro=clc.id;
                this.texto_nombre_campo=clc.campo_nombre;
                this.id_relantionship=clc.id_relationship;
                this.list_campos=this.verificarCampoUso(clc.id_relationship);
            }
            this.validar_eliminar=false;
        },
        deleteCalculo(){
            axios.post(`${process.env.APP_URL}/calculo-deleted`, {id: this.id_registro, id_relantionship:this.id_relantionship})
            .then((response)=>{
                this.notifications(response.data.code,response.data.message);
                this.findCalculos();
                this.id_registro=0;
                this.texto_nombre_campo='';
                this.id_relantionship=0;
            }).catch(error=>{
                console.log(error);
                this.notifications(400,"Error al actualizar la renumeración");
            });
        },
        calculoRegistros(){
            this.data_calculo_registro=[];
        },
        sortableAgrupacion(){
            let orden = [];
            let num=0;
            $("input:checkbox[name=iAgrupacion]:unchecked").each(function(){
                if($(this).val() !="on"){
                    num++;
                    orden.push({id:$(this).val(), orden:num});
                }
            });
            axios.post(`${process.env.APP_URL}/guardar-orden-agrupacion`, {data: orden}).then((response)=>{
                this.findAgrupaciones(false,false);
            }).catch(error=>{
                console.log(error);
                this.notifications(400,"Error al actualizar la renumeración");
            });
        },
        sortableCampos(){
            let orden = [];
            let num=0;
            $("input:checkbox[name=iCampos]:unchecked").each(function(){
                if($(this).val() !="on"){
                    num++;
                    orden.push({id:$(this).val(), orden:num});
                }
            });
            axios.post(`${process.env.APP_URL}/guardar-orden`, {data: orden}).then((response)=>{
                this.findAgrupaciones(false,false);
                this.findCalculosCampos();
            }).catch(error=>{
                console.log(error);
                this.notifications(400,"Error al actualizar la renumeración");
            });
        },
        sortableCalculos(){
            let orden = [];
            let num=0;
            $("input:checkbox[name=iCalculos]:unchecked").each(function(){
                if($(this).val() !="on"){
                    num++;
                    orden.push({id:$(this).val(), orden:num});
                }
            });
            axios.post(`${process.env.APP_URL}/calculo-orden`, {data: orden,id_tramite:this.tramite}).then((response)=>{
            }).catch(error=>{
                console.log(error);
                this.notifications(400,"Error al actualizar la renumeración");
            });
        },
        verificarCampoUso(id){
            let uso=[];
            this.data_calculos.forEach((item)=>{
                let c_nombre='';
                if(typeof(item.formula)!="undefined"){
                    item.formula.forEach((f)=>{
                        if(typeof(f.calculo)!="undefined"){
                           f.calculo.forEach((c)=>{
                                if(typeof(c.relationship)!="undefined"){
                                    if(parseFloat(c.relationship)==parseFloat(id)){
                                       c_nombre=item.campo_nombre;
                                    }
                                }
                            });
                        }
                    });
                }
                if(c_nombre!=''){
                    uso.push(c_nombre);
                }
            });
            return uso;
        },
        validaCarctarteristica(data_){
            let v=false;
            let dta=JSON.parse(data_);
            if(typeof(dta.valor_operacion)!="undefined"){
                if(dta.valor_operacion ==true){
                    v=true;
                }
            }
            return v;
        },
        clearFormCaracteristica(){
            this.id_registro=0;
            this.caract_nombre='';
            this.caract_value='';
            this.es_caracteristica=false;
        },
        clearFormCategoria(){
            this.nombre_grupo='';
            this.id_registro=0;
        },
        clearAgrupacion(){
            this.id_registro=0;
            this.nombre_agrupacion='';
            this.id_relantionship=0;
            this.texto_nombre_campo=0;
        },
        clearFormConfig(){
            this.id_registro=0;
            this.campos=0;
            this.tamanio=0;
            this.tipo=0;
            this.expreg=0;
            this.origen=0;
            this.etiqueta='';
            this.formato=0;
            this.opciones=[];
            this.nueva_opcion_clave='';
            this.nueva_opcion_nombre='';
            this.nueva_partida=0;
            this.cancelarEdicionOpcion();
            this.requerido='false';
            this.dependiente='false';
            //this.hiddenCampos();
            this.unchecks_inputs();
            this.valor_dependiente='';
            this.campo_dependiente=0;
            this.disable_operacion=false;
        },
        hiddenCampos(){
            this.hidden_expreg=false;
            this.hidden_dates(false,false,false,false,false);
            this.hidden_numeric=false;
            this.hidden_decimal=false;
            this.hidden_file=false;
            this.hidden_origen=false;
        },
        hidden_dates(rango,mult,mes,limite,r_limite){
            this.hidden_date_rango=rango;
            this.hidden_date_multiple=mult;
            this.hidden_date_mes=mes;
            this.hidden_date_limite=limite;
            this.hidden_date_rango_limite=r_limite;
        },
        unchecks_inputs(){
            this.valor_ayuda='';
            this.valor_min='';
            this.valor_max='';
            this.decimal_longitud='';
            $("#miles").prop("checked", false);
            $("#decimal").prop("checked", false);
            this.uncheck_dates(true,true,true,true,true);
            $("input[name=tramite_config_file_type]").prop("checked", false);
        },
        uncheck_dates(rango,mult,mes,limite,r_limite){
            if(rango){$("#date_rango").prop("checked", false);}
            if(mult){ $("#date_multiple").prop("checked", false);}
            if(mes){$("#date_mes").prop("checked", false);}
            if(limite){$("#date_limite").prop("checked", false);}
            if(r_limite){$("#date_rango_limite").prop("checked", false);}
        },
        notifications(Code,Message){
            if(Code=="200"){
                Command: toastr.success(Message, "Notifications");
            }else{
                Command: toastr.warning(Message, "Notifications");
            }
        },
        loagingC(value) {
            return Vue.filter('loadingCharge')(value);
        },
    },
    mounted() {
        window.adminConfigTramite=this;
        this.findTramites();
        this.findCampos();
        this.findTipos();
        this.findRegex();
        this.findCatalogos();
        this.findCategorias();
    },
    watch:{
        // Al cambiar de modo el nombre deja de tener sentido: la etiqueta de una
        // opcion no es una clave valida, ni al reves.
        es_caracteristica(){
            this.caract_nombre='';
        }
    }
  }
</script>
<style scoped> 
    .sortable { list-style-type: none; margin: 0; padding: 0;  }
    .sortable li { margin: 3px 3px 3px 3px; padding: 0.5em; padding-left: 1.5em; font-size: 14px; background: #fff;border-radius: 5px !important;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);}
    table.grid {
        width: 100%;
        border: none;
        background-color: #d9edf7;
        color: #333;
        padding: 0px;
        text-align: center;
    }
    table.grid td{
        border: 4px solid white;
    }
    .text-blob{
        font-weight: bold;
    }
</style>